import React, {useState} from 'react'
import {Heading, Box, Container, SelectList, TextField, Label, Text, Button, Avatar} from "gestalt";
import {SplashBackground, AirbnbButton} from '../styles/splash'
import {Link} from "react-router-dom";
import {RouteStrings} from "./Routes";
import {withRouter} from 'react-router-dom'
import logo from './WattsDownWhite.png'

const OnBoarding = ({history}) => {
    let [type, setType] = useState(null)
    let [zip, setZip] = useState(null)
    const rateOptions = [
        {
            value: "0",
            label: "Residential"
        },
        {
            value: "1",
            label: "Commercial"
        },
    ];
    return (
    <SplashBackground>
        <Container>
            <Box margin={4} height={'100vh'} flex={'grow'} direction={'column'} justifyContent={'evenly'}
                 display={'flex'}>
                <img src={logo} alt="Logo" width={65} height={75} />
                <Box paddingY={12} flex={'grow'}>
                    <Box paddingY={2}>
                    <Heading size={'md'} color={'white'}>Watts Down</Heading>
                    </Box>
                    <Heading size={'xs'} color={'white'}>Your sixth sense for the cost of electricity at home</Heading>

                    <Box paddingY={12}>
                        <Box marginTop={4}>
                        <Label htmlFor="zip">
                            <Text>Zip Code</Text>
                        </Label>
                        <TextField
                            id="zip"
                            onChange={(z) => {setZip(z.value)}}
                            placeholder="94606"
                            value={zip}
                            type="number"
                        />
                        </Box>
                        <Box marginTop={4}>
                        <Label htmlFor="city">
                            <Text>Building Type</Text>
                        </Label>
                        <SelectList
                            id="city"
                            name="city"
                            onChange={(r)=>{setType(r.value)}}
                            options={rateOptions}
                            placeholder="Commercial or Residential"
                            value={type}
                        />
                        </Box>
                    </Box>
                    <Box column={6}>
                        {console.log(zip, type)}
                        <Button disabled={!zip || !type} text="Get Started" type="submit" onClick={()=>{console.log(zip, type); history.push(RouteStrings.Display.template(zip, type))}} />
                    </Box>
                </Box>
            </Box>
        </Container>
    </SplashBackground>
    )
};

export default withRouter(OnBoarding)